import React, { FC } from 'react'

import { EuiFlexGroup, EuiSpacer, EuiText, EuiTitle } from '@elastic/eui'

import { MasterCampaignPlanResources, MasterCampaignPlanResourceType } from 'api/interfaces/MasterCampaignPlan'
import { ResearchDocumentSection } from 'features/planner/old-pages/MasterCampaignPlanPage/components/ResearchDocumentSection'

interface AdCritterAiResearchDocumentsProps {
  masterCampaignPlanResources: MasterCampaignPlanResources
  downloadPdf: (type: MasterCampaignPlanResourceType, fileName: string) => Promise<void>
}

const AdCritterAiResearchDocuments: FC<AdCritterAiResearchDocumentsProps> = ({ masterCampaignPlanResources, downloadPdf }) => {
  return (
    <div>
      <EuiFlexGroup direction='column'>
        <EuiTitle size={'xs'}>
          <p>Supporting Documents</p>
        </EuiTitle>
        <EuiText>The following documents are associated with this marketing plan and provide the context and rationale for the campaigns.</EuiText>
      </EuiFlexGroup>
      <EuiSpacer size={'xl'} />
      <div>
        <ResearchDocumentSection
          title='Campaign Details'
          description='A detailed description of each campaign showing the targeted audience, geo-targeting, dates, budget, and other considerations for each campaign.'
          onDownload={() => {
            return downloadPdf(MasterCampaignPlanResourceType.CampaignDetailsAndRationale, 'CampaignDetailsAndRationale.pdf')
          }}
          isDownloadDisabled={!masterCampaignPlanResources.campaignDetailsAndRationaleAvailable}
        />
        <EuiSpacer size={'m'} />
        <ResearchDocumentSection
          title='Marketing Plan'
          description='A summary of the marketing plan that includes specific details on the audience targeting, geo-targeting approach and seasonal considerations. It also includes a timeline of the campaigns.'
          onDownload={() => {
            return downloadPdf(MasterCampaignPlanResourceType.MarketingPlan, 'MarketingPlan.pdf')
          }}
          isDownloadDisabled={!masterCampaignPlanResources.marketingPlanAvailable}
        />
        <EuiSpacer size={'m'} />
        <ResearchDocumentSection
          title='Market Analysis & Targeting'
          description='Complete research on the market conditions and targeting recommendations associated with this marketing campaign.'
          onDownload={() => {
            return downloadPdf(MasterCampaignPlanResourceType.MarketAnalysis, 'MarketAnalysis.pdf')
          }}
          isDownloadDisabled={!masterCampaignPlanResources.marketingPlanAvailable}
        />
        {masterCampaignPlanResources.pitchDeckAvailable && (
          <>
            <EuiSpacer size={'m'} />
            <ResearchDocumentSection
              title='Pitch Deck'
              description='This pitch deck can be used to present the plan to your clients.'
              onDownload={() => {
                return downloadPdf(MasterCampaignPlanResourceType.PitchDeck, 'PitchDeck.pptx')
              }}
              isDownloadDisabled={!masterCampaignPlanResources.pitchDeckAvailable}
              downloadText={'Download PPT'}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default AdCritterAiResearchDocuments
